import BigNumber from 'bignumber.js'
import { calc_sqrt_price, getTokenUSDPrice, numFormat } from '../../blockchainUtils/math'
import { getToken, isSufficientBalanceInWallet } from '../../model/tokens/helper'
import { Network } from '../../services/token.service'
import { getTokenBraavosName } from '../../blockchainUtils'

export const MAX_TICK = 887272
export const EthAddress = '0x49d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7'

export function getUpdatedCratePositionUrl(params: { token1Address?: string; token2Address?: string; fee?: number; maxTick?: number; minTick?: number; range?: number }) {
    const { fee, token1Address, token2Address, minTick, maxTick, range } = params
    let url = `/create-position?`
    if (token1Address) url = url + `token0=${token1Address}`
    if (token2Address) url = url + `&token1=${token2Address}`
    if (fee) url = url + `&default_fee=${fee}`
    if (minTick) url = url + `&minTick=${minTick}`
    if (maxTick) url = url + `&maxTick=${maxTick}`
    if (range) url = url + `&range=${range}`
    return url
}

export function getNewCurrentRatio(network: Network, number: number, token1: string, token2: string) {
    let normalizedToken0 = token1
    let normalizedToken1 = token2
    if (BigNumber(token1).gt(token2)) {
        normalizedToken0 = token2
        normalizedToken1 = token1
    }
    let newRatio = calc_sqrt_price(new BigNumber(1 / number), getToken(network, normalizedToken0)!.decimals!, getToken(network as Network, normalizedToken1)!.decimals)
    return newRatio
}

export function getIsNextCreatePositionStepDisabled(
    isTxInProgress: boolean,
    stepNumber: number,
    token1: string,
    token2: string,
    fee: number,
    isCreatePoolPage: boolean,
    isCalculatingRatioNewPool: boolean,
    isTokensReversedFromPool: boolean,
    network: Network,
    token1Amount: string,
    token2Amount: string,
    userSelectedMinTick: number,
    userSelectedMaxTick: number,
    minTick: number,
    maxTick: number,
    currentTick: number
) {
    if (isTxInProgress) return true
    if (stepNumber === 1) return !token1 || !token2
    if (stepNumber === 2) return !fee
    if (stepNumber === 3 && !isCreatePoolPage) return false
    if (stepNumber === 3 && isCreatePoolPage) return isCalculatingRatioNewPool || !fee
    const isSuffToken1 = isSufficientBalanceInWallet(network!, token1, token1Amount)
    const isSuffToken2 = isSufficientBalanceInWallet(network!, token2, token2Amount)
    if (stepNumber === 4) {
        const mnTick = userSelectedMinTick ? userSelectedMinTick : minTick
        const mxTick = userSelectedMaxTick ? userSelectedMaxTick : maxTick
        const token1Disabled = isTokensReversedFromPool ? currentTick < mnTick : currentTick > mxTick
        const token2Disabled = isTokensReversedFromPool ? currentTick > mxTick : currentTick < mnTick
        const haveToken1 = token1Amount || token1Disabled
        const haveToken2 = token2Amount || token2Disabled
        return !haveToken1 || !haveToken2 || !token1 || !token2 || !isSuffToken1 || !isSuffToken2 || (Number(token1Amount) === 0 && Number(token2Amount) === 0)
    }
    return true
}

export function getMinMaxTickState(userSelectedMinTick: number, minTick: number, userSelectedMaxTick: number, maxTick: number) {
    const minTickState = userSelectedMinTick ? userSelectedMinTick : minTick
    const maxTickState = userSelectedMaxTick ? userSelectedMaxTick : maxTick

    return { minTickState, maxTickState }
}

export function getDepositTotalAmount(
    network: string,
    token1: string,
    token2: string,
    token1Amount: string,
    token2Amount: string,
    getUsdPrice: (tokenName: string) => {
        usd: number
    }
) {
    if (!network || !token1 || !token2) return '-'
    const token1Obj = getToken(network!, token1!)
    const token2Obj = getToken(network!, token2!)
    const token1UsdAmountInput =
        getUsdPrice(getTokenBraavosName(token1Obj ? token1Obj.symbol : '')) && getUsdPrice(getTokenBraavosName(token1Obj ? token1Obj.symbol : '')).usd
            ? getUsdPrice(getTokenBraavosName(token1Obj ? token1Obj.symbol : '')).usd
            : 0
    const token2UsdAmountInput =
        getUsdPrice(getTokenBraavosName(token2Obj ? token2Obj.symbol : '')) && getUsdPrice(getTokenBraavosName(token2Obj ? token2Obj.symbol : '')).usd
            ? getUsdPrice(getTokenBraavosName(token2Obj ? token2Obj.symbol : '')).usd
            : 0
    const token1UsdAmount = getTokenUSDPrice(Number(token1Amount), token1UsdAmountInput)
    const token2UsdAmount = getTokenUSDPrice(Number(token2Amount), token2UsdAmountInput)

    return `$${numFormat((Number(token1UsdAmount) + Number(token2UsdAmount)).toString(), false)}`
}
